'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fileIsUploadingInThread = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fileIsUploadingInThread = exports.fileIsUploadingInThread = function fileIsUploadingInThread(_ref, state) {
  var localId = _ref.localId,
      threadId = _ref.threadId;

  return Boolean((0, _getIn2.default)([threadId, localId], state));
};